import { useState, type FormEvent } from 'react'
import { Link, useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Archive, Camera, Search } from 'lucide-react'
import { api } from '../lib/api'
import { useAuth } from '../lib/auth'
import { QuickCommand } from '../components/QuickCommand'
import { Alert, ErrorAlert } from '../components/ui'

/**
 * Accueil : une question (« Tu cherches quoi ? ») avec un grand champ de recherche, deux grandes actions (une
 * seule en couleur), puis la commande rapide.
 */
export function Home() {
  const { t } = useTranslation()
  const { me } = useAuth()
  const [sent, setSent] = useState(false)
  const [error, setError] = useState<unknown>(null)
  const [q, setQ] = useState('')
  const navigate = useNavigate()
  const user = me!.user
  const search = (e: FormEvent) => {
    e.preventDefault()
    void navigate(q.trim() ? `/search?q=${encodeURIComponent(q.trim())}` : '/search')
  }

  return (
    <>
      <p className="home-hello">{t('home.hello', { name: user.displayName })}</p>
      <h1>{t('home.question')}</h1>
      <form role="search" className="home-search" onSubmit={search}>
        <Search aria-hidden size={24} />
        <input
          type="search"
          aria-label={t('home.findItem')}
          placeholder={t('home.searchPlaceholder')}
          value={q}
          onChange={(e) => setQ(e.target.value)}
          maxLength={200}
        />
        <button type="submit" className="btn">
          {t('inventory.searchSubmit')}
        </button>
      </form>
      {!user.emailVerified && (
        <Alert kind="warning">
          <p>{t('home.verifyEmailBanner')}</p>
          {sent ? (
            <p>{t('home.verificationSent')}</p>
          ) : (
            <button
              type="button"
              className="btn secondary"
              onClick={async () => {
                try {
                  await api.post('/auth/email/resend')
                  setSent(true)
                } catch (e) {
                  setError(e)
                }
              }}
            >
              {t('home.resendVerification')}
            </button>
          )}
        </Alert>
      )}
      <ErrorAlert error={error} />
      <nav className="big-actions" aria-label={t('nav.home')}>
        <Link className="big-action primary" to="/add">
          <Camera aria-hidden size={32} />
          {t('home.addItem')}
        </Link>
        <Link className="big-action" to="/storage">
          <Archive aria-hidden size={32} />
          {t('home.browse')}
        </Link>
      </nav>
      <p>
        <Link to="/aide">{t('help.homeLink')}</Link>
      </p>
      <QuickCommand />
    </>
  )
}
